import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

const WD = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
const MONTHS = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

export const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const formatCH = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
};

export const Calendar = ({ value, onChange }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [view, setView] = useState(() => (value ? new Date(value) : new Date(today.getFullYear(), today.getMonth(), 1)));
  const first = new Date(view.getFullYear(), view.getMonth(), 1);
  const offset = (first.getDay() + 6) % 7;
  const days = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
  const max = new Date(today);
  max.setMonth(max.getMonth() + 3);
  const canPrev = new Date(view.getFullYear(), view.getMonth(), 1) > new Date(today.getFullYear(), today.getMonth(), 1);
  const canNext = new Date(view.getFullYear(), view.getMonth() + 1, 1) <= max;

  return (
    <div className="rounded-2xl border hairline bg-[color:var(--surface)] p-5 md:p-7 max-w-md" data-testid="booking-calendar">
      <div className="flex items-center justify-between mb-6">
        <p className="text-[19px] font-medium tracking-[-0.01em]" aria-live="polite">{MONTHS[view.getMonth()]} {view.getFullYear()}</p>
        <div className="flex gap-1">
          <button type="button" aria-label="Vorheriger Monat" disabled={!canPrev} data-testid="calendar-prev" onClick={() => setView(new Date(view.getFullYear(), view.getMonth() - 1, 1))} className="h-10 w-10 rounded-full border hairline flex items-center justify-center disabled:opacity-30 hover:border-[color:var(--ink)] transition-colors"><ChevronLeft className="h-4 w-4" /></button>
          <button type="button" aria-label="Nächster Monat" disabled={!canNext} data-testid="calendar-next" onClick={() => setView(new Date(view.getFullYear(), view.getMonth() + 1, 1))} className="h-10 w-10 rounded-full border hairline flex items-center justify-center disabled:opacity-30 hover:border-[color:var(--ink)] transition-colors"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      <div className="grid grid-cols-7 mb-2">
        {WD.map((w) => <span key={w} className="mono text-[11px] text-center text-[color:var(--ink-3)] uppercase tracking-widest">{w}</span>)}
      </div>
      <div className="grid grid-cols-7 gap-y-1" role="grid">
        {Array.from({ length: offset }).map((_, i) => <span key={`e${i}`} />)}
        {Array.from({ length: days }).map((_, i) => {
          const d = new Date(view.getFullYear(), view.getMonth(), i + 1);
          const iso = toISO(d);
          const sunday = d.getDay() === 0;
          const disabled = d < today || d > max || sunday;
          const selected = value === iso;
          return (
            <button key={iso} type="button" disabled={disabled} aria-pressed={selected} aria-label={formatCH(iso)} data-testid={`calendar-day-${iso}`} onClick={() => onChange(iso)}
              className={cn("h-11 w-11 mx-auto rounded-lg text-[15px] tabular-nums transition-[background-color,color] duration-300", disabled ? "text-[color:var(--ink)]/20 cursor-not-allowed" : selected ? "bg-[#7540b7] text-white font-medium" : "hover:bg-[color:var(--violet-soft)]", !selected && toISO(today) === iso && "ring-1 ring-inset ring-[color:var(--violet)]")}>
              {i + 1}
            </button>
          );
        })}
      </div>
      <p className="mt-5 text-[12px] text-[color:var(--ink-3)]">Wunschtermin – kein verbindlicher Buchungsslot. Wir bestätigen den Termin persönlich.</p>
    </div>
  );
};
